const quotaTip = {
  approvalNum: '待审批任务数量',
  approvalTimeAvg: '截止今日0时审批所花时间/审批次数(排除自动审批)；',
  approvalTimeFastPercent: '截止今日0时（排名池总人数-本人平均耗时排名数）/排名池总人数*100%',
  approvalTotal: '截止今日0时同意+拒绝的次数',
}

const bgImgMap = {
  0: require('@/assets/images/top2.png'),  
  1: require('@/assets/images/top1.png'),
  2: require('@/assets/images/top3.png'),
}

export {
  bgImgMap,
  quotaTip
}